import {EntryDesc} from 'generated/JavaTOmodifications';

export function getCustomFieldsFrom(e: EntryDesc | undefined, selfAdmin: boolean) {
	if (!e) return []
	if (selfAdmin && e.rulesetSelfAdmin) {
		return e.rulesetSelfAdmin.customFieldDefinitions
	} else {
		return e.customFieldDefinitions
	}
}